module.exports = __webpack_public_path__ + "static/media/icon_neironghegui.b66a346b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/icon_neironghegui.svg
// module id = 615
// module chunks = 0